






















































































import { Component } from 'vue-property-decorator';
import PoolsFilter from "@/components/Settings/Pools/PoolsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {PoolItem} from "@/store/settings/pools/types";

@Component({components:{PoolsFilter,ScrollButton}})
export default class Pools extends BaseItemsPage<PoolItem> {
  @Getter("pools") poolsResponse!: PoolItem[];
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";

  tableFields = [
    'name',
    'description',
    'originators',
    'originators_count',
  ];

  getData(): PoolItem[] {
    return this.poolsResponse;
  }
}
